import React from "react";
import {Route, Switch} from "react-router-dom";
import Dashboard from './containers/requiredAuth/Dashboard'
//import Home from './containers/Home'

import Search from './containers/requiredNoAuth/Search'
import Connexion from './containers/requiredNoAuth/Connexion'
import Inscription from './containers/requiredNoAuth/Inscription'
import Favorites from './containers/requiredAuth/Favorites'
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import requireAuth from "./middleware/requireAuth";
import requireEntreprise from "./middleware/requireEntreprise";
import requireAdmin from "./middleware/requireAdmin";
import RecipePage from "./containers/requiredNoAuth/RecipePage";
import Ingredients from "./containers/requiredAuth/Ingredients";
import UpdateAccount from "./containers/requiredAuth/UpdateAccount";
import requireNoAuth from "./middleware/requireNoAuth";
import ForgotPassword from "./containers/requiredNoAuth/ForgotPassword";
import Home from "./containers/requiredNoAuth/Home";
import CreateUser from "./containers/requiredAuth/CreateUser"
import CreatePost from "./containers/requiredAuth/CreatePost"
import Cartography from "./containers/requiredNoAuth/Cartography"

const Container = (props) => (
    <div>
        <Route exact path="/accueil" component={Dashboard}/>
        <Route exact path="/ingredients" component={Ingredients}/>
        <Route exact path="/favorites" component={Favorites}/>
        <Route exact path="/post/creer" component={requireEntreprise(CreatePost)}/>
        <Route exact path="/utilisateur/creer" component={requireAdmin(CreateUser)}/>
        <Route exact path="/profil/informations" component={UpdateAccount}/>
    </div>
);

function Routes(props) {

    return (
        <Switch>
            <Route exact path="/" component={Home}/>
            <Route exact path="/connexion" component={requireNoAuth(Connexion)}/>
            <Route exact path="/search" component={Search}/>
            <Route exact path="/inscription" component={requireNoAuth(Inscription)}/>
            <Route exact path="/destockage" component={Cartography}/>
            <Route path="/recettes" component={RecipePage}/>
            <Route exact path="/profil/motdepasse" component={requireNoAuth(ForgotPassword)}/>
            <Route component={requireAuth(Container)}/>
        </Switch>
    );
}


const mapStateToProps = ({auth}) => {
    return {auth}
}

export default withRouter(connect(
    mapStateToProps,
    {}
)(withRouter(Routes)))
